var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAchHut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 9.67969H15.797V14.2308H14.1875V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1953 9.67969H11.805V14.2308H10.1953V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19531 9.67969H7.80498V14.2308H6.19531V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21094 9.67969H3.82046V14.2308H2.21094V9.67969Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50781 7.57422H16.5085V7.85163C16.5085 8.00484 16.3842 8.12905 16.2311 8.12905H1.78523C1.63198 8.12905 1.50781 8.00488 1.50781 7.85163V7.57422Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.527416 15.7891H17.4742C17.6275 15.7891 17.7516 15.9132 17.7516 16.0665V17.4729C17.7516 17.6262 17.6275 17.7503 17.4742 17.7503H0.527416C0.374172 17.7503 0.25 17.6262 0.25 17.4729V16.0665C0.25 15.9132 0.374172 15.7891 0.527416 15.7891Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6204 5.50711L17.6205 5.50715C17.726 5.57203 17.7757 5.6993 17.742 5.8189C17.7081 5.93832 17.5991 6.02076 17.475 6.02076H0.527369C0.403414 6.02076 0.29437 5.93835 0.260551 5.8189C0.226725 5.69943 0.27629 5.57217 0.381985 5.50708L8.85573 0.291203C8.85573 0.291198 8.85574 0.291193 8.85575 0.291189C8.94505 0.236246 9.05751 0.236306 9.14656 0.291155L9.14662 0.291189L17.6204 5.50711ZM9.3598 2.85214H8.6427C8.21332 2.85214 7.86529 3.20017 7.86529 3.62956C7.86529 4.05894 8.21332 4.40697 8.6427 4.40697H9.3598C9.78918 4.40697 10.1372 4.05894 10.1372 3.62956C10.1372 3.20017 9.78919 2.85214 9.3598 2.85214Z",
    stroke: "#2C3E50",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAchHut);
export default __webpack_public_path__ + "static/media/bank-ach-hut.cb22c69a6f9dcc9fc830369284032cff.svg";
export { ForwardRef as ReactComponent };